import React from 'react'

import { Portlet } from '_zari/core'

import MainForm from './mainForm'

const MainPage = () => {
  return (
    <Portlet>
      <Portlet.Header title='Ingreso Guia - Ya emitidas' />
      <Portlet.Body>
        <MainForm />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(MainPage)
